var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "209.17mm",
    height: "110.32mm",
    viewBox: "0 0 209.17 110.32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.0023551 2.9021)",
    fill: "#00c0ff",
    stroke: "#000",
    strokeWidth: 0.37118
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.0789 .56696)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6228 2.6727)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.644,
    y: 4.415,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.644,
    y: 24.044,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -43.673,
    y: 48.273,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.8607 -4.2763)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.035,
    y: 61.311,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 61.311,
    y: -28.035,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.035,
    y: 80.94,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.0789 .56696)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.928 .69546)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 6.0211,
    y: -104.51,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.51,
    y: 6.0211,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.51,
    y: 25.65,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 290.71 -3.9449)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -100.61,
    y: 90.338,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.97,
    y: 60.979,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.97,
    y: 80.608,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.1838 .56696)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.40941 .57037)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.376,
    y: 6.3318,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.376,
    y: 25.961,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.39 -23.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -59.602,
    y: 80.223,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: -59.602,
    y: 99.852,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTables);
export default __webpack_public_path__ + "static/media/group_tables.1e4624e8f921bbbdf52bcf7738fb2c51.svg";
export { ForwardRef as ReactComponent };